import { configureStore } from "@reduxjs/toolkit";

import { rootReducer, RootReducerType } from "../slices/rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
export type AppState = ReturnType<RootReducerType>;
